<template lang="html">
  <div class="projectWrapper" :class="{maximized:expanded}">
    <!-- minimized - square -->
    <div v-show="!expanded" class="projectMinWrapper">
      <div
        class="projectMin"
        :class="{dark: darkmode}"
        @click="handleClick"
      >
        {{shortTitle}}
      </div>
    </div>
    <!-- maximized - open window -->
    <div v-show="expanded" class="projectMaxWrapper" :class="{dark:darkmode}">
      <div class="contentWrapper">
        <div class="head">
          <h1>{{projectTitle}}</h1>
          <AveIcon icon="edit" v-show="!visibleProjectEdit" @click="visibleProjectEdit = true"/>
        </div>
      </div>

        <AveProjectEdit v-show="visibleProjectEdit" :darkmode="darkmode" :currentTitle="projectTitle" @editProject="emitEdit" @deleteProject="emitDelete"/>

        <AveAddTodo :darkmode="darkmode" :visible="!visibleEdit" @click="visibleEdit = true" />

        <AveAddEditToDo
        :darkmode="darkmode"
        :visible="visibleEdit"
        :errorType="errorType"
        label="Close"
        type="add"
        @emitInputs="addToDo"
        @hideDelete="visibleEdit = !visibleEdit"
        />
        <!-- <transition-group class="todo-list"> -->
        <AveTodo
        :darkmode="darkmode"
        v-for="(todo) in todos"
        @deleteTodo="deleteTodo"
        @done ="markAsDone"
        @editTodo="editTodo"
        :key="todo.id"
        :title="todo.title"
        :time="todo.time"
        :donetime="todo.donetime"
        :label="todo.label"
        :creationDate="todo.creationDate"
        :done="todo.done"
        :tracking="todo.tracking"
        :id="todo.id"
        :projectId="todo.projectId"
        />
      <!-- </transition-group> -->


      </div>

  </div>

</template>

<script>
import AveTodo from '@/components/AveTodo.vue';
import AveIcon from '@/components/AveIcon.vue';
import AveAddEditToDo from '@/components/AveAddEditToDo.vue';
import AveAddTodo from '@/components/AveAddTodo.vue';
import AveProjectEdit from '@/components/AveProjectEdit.vue';

import db from '@/db';

export default {
  components: {
    AveTodo,
    AveIcon,
    AveAddTodo,
    AveAddEditToDo,
    AveProjectEdit,
  },
  computed: {
    currentTrackingId() {
      return this.$store.state.currentTrackingId;
    },
    hide() {
      return !this.visibleEdit;
    },
    shortTitle() {
      const name = `${this.projectTitle[0]}${this.projectTitle[1]}`;
      return name.toLowerCase();
    },
    // visibleProjectEdit() {
    //   return true;
    // },
  },
  async created() {
    try {
      // // console.log(this.id);
      // Es werden nur die Todos aus der Datenbank geladen, die zum aktuellen Projekt passen
      this.todos = await db.todos.where('projectId').equals(this.id).reverse().toArray();
    } catch (err) {
      console.warn(`Error fetching todos: ${err.message}`);
    }
  },
  // mounted() {
  //   this.todos.push({ ...this.initialtodo });
  //   // this.todos.push(this.initialtodo);
  //   // console.log(this.todos);
  // },
  props: {
    darkmode: Boolean,
    expanded: Boolean,
    id: Number,
    projectTitle: {
      type: String,
      default: 'ww',
    },
    initialtodo: Object,
  },
  data() {
    return {
      visibleEdit: false,
      errorType: '',
      todos: [],
      editProject: true,
      visibleProjectEdit: false,
    };
  },

  methods: {
    expand(e) {
      if (this.$el.contains(e.target) || this.$el === e.target) return;
      this.$emit('expand', this.id);
    },

    handleClick() {
      this.$emit('expand', this.id);
    },

    emitDelete() {
      this.$emit('emitDelete', this.id);
      this.visibleProjectEdit = false;
    },

    emitEdit(data) {
      const changes = { id: this.id, title: data };
      this.$emit('emitEdit', changes);
      this.visibleProjectEdit = false;
    },

    async addToDo(data) {
      // data -> title, time, label, creationDate
      // todo: title: data.title, time: data.time, donetime: 0, label: data.label, creationDate: data.creationDate, done: false, tracking: false,
      const todo = {
        title: data.title,
        time: data.time,
        label: data.label,
        creationDate: data.creationDate,
        donetime: 0,
        done: 0,
        tracking: false,
        projectId: this.id,
        startTracking: 0,
        endTracking: 0,
      };
      // this.parseInputToMilli(todo.time);
      try {
        // pushing new todo into database
        const newId = await db.todos.add(todo);
        // pushing new todo with new id into view array
        this.todos.unshift({ id: newId, ...todo });
      } catch (err) {
        console.warn(`Error pushing new todo into db: ${err.message}`);
      }
      this.visibleEdit = false;
    },

    async editTodo(data) {
      const currentTodo = data.id;
      let index = 0;
      for (let i = 0; i < this.todos.length; i += 1) {
        if (this.todos[i].id === currentTodo) {
          index = i;
        }
      }
      try {
        // updating properties in database
        await db.todos.update(currentTodo, {
          title: data.title,
          time: data.time,
          donetime: data.donetime,
          label: data.label,
        });
        // editing properties in view
        this.todos[index].title = data.title;
        this.todos[index].time = data.time;
        this.todos[index].donetime = data.donetime;
        this.todos[index].label = data.label;
      } catch (err) {
        console.warn(`Error editing todos: ${err.message}`);
      }
    },

    deleteTodo(data) {
      // starting a toasty before deleting
      this.$store.commit('addToasty', {
        // action prop to delete Todo
        action: async () => {
          try {
            // deleting todo in database with current id
            await db.todos.delete(data);
            // Wenn todo trackt sollte es geschlossen werden
            await this.$store.dispatch('stopTracking');
            for (let i = 0; i < this.todos.length; i += 1) {
              if (this.todos[i].id === data) {
                this.todos.splice(i, 1);
              }
            }
          } catch (err) {
            console.warn(`Error deleting todo: ${err.message}`);
          }
          this.$store.commit('closeToasty', this.$store.state.toasties[this.$store.state.toasties.length - 1].id);
        },
        labelClose: 'Oh no, don\'t delete it!',
        labelConfirm: 'It\'s alright!',
        iconClose: 'wrong',
        iconConfirm: 'done',
        text: 'You seem to have deleted this To Do. Would your like to rebuild it?',
      });
    },

    async markAsDone(data) {
      // Suche nach dem Todo das gerade abgehackt wird
      const index = this.todos.findIndex((todo) => todo.id === data);

      // Auf Undone stellen
      if (this.todos[index].done) {
        try {
          await db.todos.update(data, { done: 0 });
          this.todos[index].done = 0;
        } catch (err) {
          console.warn(`Error upadting done status: ${err.message}`);
        }
      // Auf Done Stellen
      } else {
        if (this.todos[index].id === this.$store.state.currentTrackingId) {
          this.$store.dispatch('stopTracking');
        }
        try {
          await db.todos.update(data, { done: 1, tracking: false });
          this.todos[index].done = 1;
          this.todos[index].tracking = false;
        } catch (err) {
          console.warn(`Error upadting done status: ${err.message}`);
        }
      }
    },
  },
  watch: {
    expanded(newValue) {
      // console.log(newValue);
      if (newValue) {
        window.addEventListener('click', this.expand, true);
      } else {
        window.removeEventListener('click', this.expand, true);
      }
    },
    currentTrackingId(newValue, oldValue) {
      if (newValue === -1 && oldValue !== -1) {
        const lastTodo = this.todos.find((todo) => todo.id === oldValue);
        // console.log(lastTodo);
        lastTodo.donetime = this.$store.state.currentTrackingDoneTime;
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
@require '../assets/styles/colors.styl'
@require '../assets/styles/styles.styl'
@require '../assets/styles/base.styl'

.projectWrapper
    &.maximized
      grid-column-end: span 2

// Styling of Square Project
.projectMin
  font-size $projectMinFontSize
  font-weight $projectMinFontWeight
  color $normal
  background-color $white
  border $borderBoxes
  border-color $normal
  box-shadow $shadow
  border-radius $radiusBoxes
  outline none
  display flex
  align-items center
  justify-content center

  &.dark
    background-color $normal
    border-color $darkmodeWhite
    box-shadow $darkmodeShadow
    color $darkmodeWhite

.projectMin:after
  content ""
  display block
  padding-bottom 100%

.projectMin:hover
  cursor: pointer;

// Styling of expanded Project

// Wrapper einstellungen für das Grid

.projectMinWrapper
  background-color: $darkmodeWhite

.projectMaxWrapper
  border: $borderBoxes
  border-radius: $radiusBoxes
  box-shadow $darkmodeShadow

  .contentWrapper
    width $contentWrapperWidth
    padding-top $marginBottom
    margin auto

  &.dark
    background-color $normal
    border-color $darkmodeWhite
    box-shadow $darkmodeShadow
    color $darkmodeWhite

  .head
    display flex
    flex-direction row
    justify-content space-between
    align-items baseline

.add-edit-todo
  width $contentWrapperWidth
  padding-top $marginBottom
  margin auto

.editProject
  width $contentWrapperWidth
  padding-top $marginBottom
  margin auto
  margin-bottom $marginBottom
// .todo-list
//   position: relative;
//
//   .todo-item
//
//     &.v-enter-avtive,
//     &.v-leave-active,
//     &v-move
//       transition: transform 200ms ease, opacity 200ms ease
//
//       &.v-enter,
//       &.v-leave-to
//         transform: translateX(20px)
//         opacity: 0
//         &.v-leave-active
//           positiom: absolute
//           width: 100%

</style>
